import { Box, Divider, Text, HStack } from '@chakra-ui/layout';
import { Button, Tabs, TabList, TabPanels, TabPanel, Tab, Spinner } from '@chakra-ui/react';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { GlobalTable } from '../../withdrawal/components/global-table-template';
import { syncDataPlans, getCableSubscription } from '../service';
import { CableSubscriptionTableBody } from './table-data/TableBody';
import { CableSubscriptionTableHead } from './table-data/TableHead';

const CABLE_PROVIDERS = [
  { id: 'dstv', name: 'DSTV', label: 'DSTV' },
  { id: 'gotv', name: 'GOtv', label: 'GOtv' },
  { id: 'startimes', name: 'Startimes', label: 'Startimes' }
];

export const CableSubscription = () => {
  const userId = useSelector((state) => state.auth.user);
  const [syncLoading, setSyncLoading] = useState(false);
  const [providerData, setProviderData] = useState({});
  const [loadingStates, setLoadingStates] = useState({});
  const [activeTab, setActiveTab] = useState(0);

  const loadProviderData = async (provider) => {
    setLoadingStates(prev => ({ ...prev, [provider.id]: true }));
    try {
      const data = await getCableSubscription(userId, provider.id);
      setProviderData(prev => ({
        ...prev,
        [provider.id]: data
      }));
    } catch (error) {
      console.error(`Error loading ${provider.name} data:`, error);
    } finally {
      setLoadingStates(prev => ({ ...prev, [provider.id]: false }));
    }
  };

  useEffect(() => {
    // Load data for the active tab only
    const currentProvider = CABLE_PROVIDERS[activeTab];
    if (!providerData[currentProvider.id]) {
      loadProviderData(currentProvider);
    }
  }, [activeTab]);

  const handleTabChange = (index) => {
    setActiveTab(index);
  };

  return (
    <Box
      m='10px 0'
      p={['10px', '20px']}
      bg='#fff'
      boxShadow='md'
      borderRadius='5px'
    >
      <HStack justify='space-between' mb='10px'>
        <Text color='#8366A5'>
          <b>Cable Subscription</b>
        </Text>
        <Button
          isLoading={syncLoading}
          onClick={() => syncDataPlans(userId, setSyncLoading)}
          color='#FF6F6F'
          variant='outline'
          size='xs'
        >
          Sync prices
        </Button>
      </HStack>
      <Divider />
      <Tabs variant='soft-rounded' colorScheme='purple' mt={4} index={activeTab} onChange={handleTabChange}>
        <TabList>
          {CABLE_PROVIDERS.map((provider, index) => (
            <Tab key={provider.id}>{provider.label}</Tab>
          ))}
        </TabList>
        <TabPanels>
          {CABLE_PROVIDERS.map((provider) => (
            <TabPanel key={provider.id}>
              <Box h='300px' overflow='auto' position="relative">
                {loadingStates[provider.id] ? (
                  <Box display="flex" justifyContent="center" alignItems="center" height="100%">
                    <Spinner size="xl" color="purple.500" />
                  </Box>
                ) : (
                  <GlobalTable
                    tableHead={<CableSubscriptionTableHead />}
                    tableBody={<CableSubscriptionTableBody Data={providerData[provider.id] || []} />}
                    striped={false}
                  />
                )}
              </Box>
            </TabPanel>
          ))}
        </TabPanels>
      </Tabs>
    </Box>
  );
};
